import React from 'react';

const GalleryPrint = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<g>
				<path
					d="M6.48914 17.5474C4.95493 17.5474 3.59026 16.5223 3.09467 14.9963L3.06116 14.8813C2.94427 14.4772 2.8953 14.1373 2.8953
					13.7973V6.97899L0.570355 15.0772C0.271347 16.2684 0.952739 17.5033 2.09599 17.8323L16.9152 21.9735C17.0954 22.0225 17.2809
					22.0473 17.4672 22.0475C18.4216 22.0475 19.2938 21.3865 19.5382 20.4123L20.4016 17.5474H6.48914ZM9.12469 7.0471C10.1818 7.0471
					11.0413 6.15003 11.0413 5.04699C11.0413 3.94394 10.1818 3.04688 9.12469 3.04688C8.06756 3.04688 7.20791 3.94399 7.20791 5.04699C7.20791
					6.14999 8.0676 7.0471 9.12469 7.0471Z"
					fill="#80D33F"
				/>
				<path
					d="M21.1032 0.046875H6.72787C5.4074 0.046875 4.33203 1.169 4.33203 2.54706V13.5472C4.33203 14.9253 5.4074 16.0474 6.72787
					16.0474H21.1032C22.4239 16.0474 23.4992 14.9253 23.4992 13.5472V2.54706C23.4992 1.169 22.4239 0.046875 21.1032 0.046875ZM6.72787
					2.04699H21.1032C21.3679 2.04699 21.5825 2.27096 21.5825 2.54706V9.64623L18.5551 5.96007C18.234 5.56711 17.7691 5.35706 17.2699
					5.3452C16.7735 5.3481 16.3077 5.57808 15.9896 5.97615L12.4301 10.4342L11.2705 9.22711C10.6151 8.54318 9.5484 8.54318 8.89383
					9.22711L6.24881 11.9862V2.54702C6.24881 2.27092 6.46345 2.04699 6.72787 2.04699Z"
					fill="#80D33F"
				/>
			</g>
		</svg>
	);
};

export default GalleryPrint;
